import { GetMachineOtaLogsAPI } from '../adapters/MachineVersionDetailsAdapter/GetMachineOtaLogsAdapter';

export const getMachineOtaLogs = (machineUDI) => {
  return new Promise((resolve, reject) => {
    GetMachineOtaLogsAPI(machineUDI)
      .then((res) => {
        if (res?.data && res.status === 200) {
          const sessions = Array.isArray(res.data.data) ? res.data.data : [];
          resolve(sessions);
          return;
        }
        reject(res?.data?.error?.message || 'Error fetching OTA logs');
      })
      .catch((err) => {
        reject(
          err?.response?.data?.error?.message ||
          err?.response?.data?.message ||
          err?.message ||
          'Error fetching OTA logs'
        );
      });
  });
};
